import { FC, ReactNode } from "react";

export interface WithProps {
  children: () => ReactNode;
}
export const With: FC<WithProps> = (props) => {
  return props.children();
};
